import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import Authentication from "../Authentication/Authentication";
import MainToolBar from "../../Component/Navigation/MainToolBar/MainToolBar";
import Spinner from "../../Component/UI/spinner/Spinner";
import DealerCard from "../../Component/DealerPage/DealerCard/DealerCard"

import * as actionCreaters from "../../Store/actions/index";
import DealerPosts from "../../Component/DealerPage/DealerPost/DealerPost";
import ContactNow from "../../Component/ContactNow/ContactNow";
import Paggination from "../../Component/UI/Paggination/Paggination";


class DealerPage extends Component {
    state = {
        dealerId : null,
        searchInput: '',
        showAuth: false,
        authMode: 'signIn'
    }


    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);
        let dealerId;
        for (let param of query.entries()) {
            dealerId = param[1]
        }
        this.setState({dealerId : dealerId})
        this.props.onGetDealer(dealerId)
        this.props.onGetDealerPosts(dealerId, null)
    }

    searchInputHandler = (value) => {
        this.setState({
            searchInput: value
        })
    }

    reLoadSearchPageHandler = () => {
        //  console.log('tes')
    }

    showAuthHandler = (mode, kepShowing) => {
        if (kepShowing) {
            this.setState({ showAuth: true })
        } else {
            this.setState((prevState) => {
                return { showAuth: !prevState.showAuth }
            })
        }
        if (mode === 'signUp') {
            this.setState({
                authMode: 'signUp'
            })
        }
        else if (mode === 'signIn') {
            this.setState({
                authMode: 'signIn'
            })
        }
        else if (mode === 'passwordReset') {
            this.setState({
                authMode: 'passwordReset'
            })
        }
        else if (mode === 'verifyEmail') {
            this.setState({
                authMode: 'verifyEmail'
            })
        }
    }

    render() {
        let DealerPage = null;
        if (this.props.loadingDealer) {
            DealerPage = (
                <Spinner />
            )
        }
        else if (this.props.dealer && this.props.dealerPosts) {
            DealerPage = (
                <Fragment>
                    <DealerCard 
                    dealer={this.props.dealer} 
                    dealerPostsLength={this.props.dealerPosts.pagination_info.resources_count}
                    />
                    <DealerPosts
                        dealerPosts={this.props.dealerPosts}
                        routProp={this.props}
                        user={this.props.user}
                        wishIdsArray={this.props.wishIdsArray}
                        showAuthHandler={this.showAuthHandler}
                        AddItemToWishList={this.props.onAddItemToUserWishList}
                        addingItem={this.props.addingItem} />
                        <Paggination paggination={this.props.dealerPosts} dealer={this.state.dealerId}/>
                </Fragment>)
        }
        return (
            <Fragment>
                {this.state.showAuth ?
                    <Authentication
                        showAuth={this.state.showAuth}
                        showAuthHandler={this.showAuthHandler}
                        authMode={this.state.authMode} />
                    :
                    null}
                <MainToolBar
                    searchInput={(value) => { this.searchInputHandler(value) }}
                    searchInputValue={this.state.searchInput}
                    props={{ ...this.props }}
                    reLoadSearchPage={this.reLoadSearchPageHandler}
                    showAuthHandler={this.showAuthHandler}
                    user={this.props.user} />
                {DealerPage}
                <ContactNow />
            </Fragment>

        );
    }
}

const mapStateToProps = state => {
    return {
        loadingDealer: state.DealerP.loadingDealer,
        dealer: state.DealerP.dealer,
        dealerPosts: state.DealerP.dealerPosts,
        error: state.DealerP.error,
        // Auth related : 
        user: state.Auth.user,
        // WishList related :
        wishIdsArray: state.WishList.wishIdsArray,
        addingItem: state.WishList.addingItem
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onGetDealer: (dealerId) => { dispatch(actionCreaters.getDealer(dealerId)) },
        onGetDealerPosts: (dealerId, pageNum) => { dispatch(actionCreaters.getDealerPosts(dealerId, pageNum)) },
        onAddItemToUserWishList : (itemId ,token) => { dispatch(actionCreaters.addItemToUserWishList(itemId,token))}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DealerPage);